<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="24" height="24" rx="3" fill="#FFD700" />
		<rect
			x="9.3913"
			y="14.6087"
			width="5.21739"
			height="5.21739"
			rx="1"
			transform="rotate(-90 9.3913 14.6087)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "LuckyDiceNeutral",
};
</script>

<style scoped></style>
